export const CATEGORY_DISPLAY_MAPPINGS = {
  "Data activation": "Analytics & Engagement",
  "Data warehouse": "Data Warehouses",
  "Direct response ads": "Search & Social",
  "Demand side platform": "Display",
  Audio: "Audio",
  Audiences: "Audience Targeting",
  CTV: "CTV",
  MMP: "Mobile Measurement",
} as const;

export function getCategoryDisplayName(category: string): string {
  return (
    CATEGORY_DISPLAY_MAPPINGS[
      category as keyof typeof CATEGORY_DISPLAY_MAPPINGS
    ] || category
  );
}
